// src/RescuePosts.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
import axios from "./axiosConfig";
import './RescuePosts.css';

function RescuePosts() {
  const [animals, setAnimals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRescueAnimals = async () => {
      try {
        // const response = await axios.get('http://localhost:8080/api/animals/post-type/rescue');
        const response = await axios.get('/api/animals/post-type/rescue');
        setAnimals(response.data);
      } catch (err) {
        console.error(err);
        setError('Failed to load rescue posts.');
      } finally {
        setLoading(false);
      }
    };

    fetchRescueAnimals();
  }, []);

  return (
    <body>
      <div className="rescue-posts-container">
      <center>
        <h1>AdoptLink</h1>
      </center>
      
        <h2>🐾 Rescue Posts</h2>

        <button className="back-button" onClick={() => navigate('/dashboard')}>
          ← Back to Dashboard
        </button>

        {loading && <p>Loading rescue posts...</p>}
        {error && <p className="error">{error}</p>}

        <div className="rescue-posts-list">
          {animals.map((animal) => (
            <div key={animal.id} className="rescue-card">
              <img src={animal.imageUrl} alt={animal.name} className="animal-image" />
              <h3>{animal.name}</h3>
              <p><strong>Type:</strong> {animal.type}</p>
              <p><strong>Breed:</strong> {animal.breed}</p>
              <p><strong>Description:</strong> {animal.description}</p>
              <p><strong>Location:</strong> {animal.location}</p>
              <a href={animal.mapLink} target="_blank" rel="noopener noreferrer">
                📍 View on Map
              </a>
            </div>
          ))}
        </div>
      </div>
    </body>
  );
}

export default RescuePosts;
